// Country ordering for the onboarding picker. Our people are overwhelmingly in
// the US, UK, Canada and India, then Europe and the rest of South Asia — so
// those come first instead of making everyone scroll past Afghanistan → Åland.

const TOP = ["US", "GB", "CA", "IN"];

const EUROPE = [
  "AL", "AD", "AT", "BY", "BE", "BA", "BG", "HR", "CY", "CZ", "DK", "EE", "FO",
  "FI", "FR", "DE", "GI", "GR", "GG", "HU", "IS", "IE", "IM", "IT", "JE", "LV",
  "LI", "LT", "LU", "MT", "MD", "MC", "ME", "NL", "MK", "NO", "PL", "PT", "RO",
  "RU", "SM", "RS", "SK", "SI", "ES", "SE", "CH", "UA", "VA",
];

const SOUTH_ASIA = ["PK", "BD", "LK", "NP", "BT", "MV", "AF"];

const byName = (a, b) => a.name.localeCompare(b.name);

/** Groups a country-state-city list into [{ label, items }] in our order. */
export function groupCountries(all) {
  const map = new Map((all || []).map((c) => [c.isoCode, c]));
  const take = (codes) => codes.map((c) => map.get(c)).filter(Boolean);
  const top = take(TOP);
  const europe = take(EUROPE).sort(byName);
  const southAsia = take(SOUTH_ASIA).sort(byName);
  const used = new Set([...top, ...europe, ...southAsia].map((c) => c.isoCode));
  const rest = (all || []).filter((c) => !used.has(c.isoCode)).sort(byName);
  return [
    { label: "Most common", items: top },
    { label: "Europe", items: europe },
    { label: "South Asia", items: southAsia },
    { label: "Everywhere else", items: rest },
  ].filter((g) => g.items.length);
}
